import en from './en.js'
import ja from './ja.js'

var data = Object.assign(en, ja)

export { data }